import React from "react";
import { PILLARS, PILLARS_TAGLINE, PILLARS_SUMMARY } from "@/lib/brand";

export default function Pillars({ variant = "full" }) {
  if (variant === "compact") {
    return (
      <div data-testid="pillars-compact" className="flex flex-col items-center text-center py-3">
        <p className="font-overline text-champagne tracking-[0.25em]">
          The Educator · The Entrepreneur · The Entertainer
        </p>
        <p className="mt-2 font-display italic text-silver text-lg md:text-xl">
          The ThrEEE's to Success<span className="text-champagne text-sm align-super ml-0.5">™</span>
        </p>
      </div>
    );
  }

  return (
    <section data-testid="pillars-section" className="relative py-24 md:py-32 px-6 md:px-12 border-y hairline overflow-hidden">
      {/* Faint giant "EEE" backdrop */}
      <div className="absolute inset-0 flex items-center justify-center pointer-events-none select-none" aria-hidden="true">
        <span className="font-display text-[28vw] md:text-[20vw] leading-none tracking-tighter text-silver/[0.035]">
          EEE
        </span>
      </div>

      <div className="relative max-w-[1440px] mx-auto">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-16">
          <div>
            <p className="font-overline text-champagne mb-4">— The Brand Pillars</p>
            <h2 className="font-display text-4xl md:text-6xl text-silver leading-[1.02] tracking-tighter">
              The ThrEEE's<br />
              <span className="italic font-light text-champagne">to Success<span className="text-base align-super ml-1">™</span></span>
            </h2>
          </div>
          <p className="font-body text-silver-muted max-w-md leading-relaxed">
            {PILLARS_SUMMARY}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-white/10 border hairline">
          {PILLARS.map((p, i) => (
            <article
              key={p.title}
              data-testid={`pillar-${p.title.toLowerCase().replace(/\s+/g, '-')}`}
              className="relative bg-navy p-10 md:p-12 hover:bg-navy-elevated transition-colors duration-500 group overflow-hidden"
            >
              <span
                className="absolute -top-6 -right-2 font-display text-[12rem] md:text-[16rem] leading-none text-silver/[0.06] group-hover:text-champagne/15 transition-colors duration-700 select-none"
                aria-hidden="true"
              >
                {p.letter}
              </span>
              <p className="relative font-overline text-champagne">{String(i + 1).padStart(2, "0")} · Pillar</p>
              <h3 className="relative mt-4 font-display text-3xl md:text-4xl text-silver leading-[1.05] tracking-tight">
                {p.title}
              </h3>
              <div className="relative mt-4 h-px w-12 bg-champagne"></div>
              <p className="relative mt-6 font-body text-silver-muted leading-relaxed">
                {p.description}
              </p>
            </article>
          ))}
        </div>

        <p className="mt-12 font-display italic text-center text-silver text-xl md:text-2xl">
          "{PILLARS_TAGLINE}" — coined by Miguel Santana.
        </p>
      </div>
    </section>
  );
}
